export default "__VITE_ASSET__8cf6712b__"